import { isDate, parse } from "date-fns";
import { parseISO as dfParseISO } from "date-fns/esm";
import { envs } from "../config";

const defaultPatter = "dd/MM/yyyy";

export const parseDateString = (strValue, pattern) => {
  if (!strValue) {
    return null;
  }
  return isDate(strValue)
    ? strValue
    : parse(strValue, pattern || defaultPatter, new Date());
};

export const parseStringDate = (date = new Date()) => {
  return isDate(date)
    ? date.toLocaleDateString(envs.locale, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : null;
};

export const parseStringDateYMD = (date = new Date()) => {
  return isDate(date)
    ? date
        .toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/-/g, "/")
    : null;
};

export const convertDataGI = (dateStr) => {
   let result = dateStr;
  if (typeof dateStr === "string") {
    if (/^\d{4}\/\d{2}\/\d{2}$/.test(dateStr)) {
      result = dateStr;
    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split("/");
      result = `${year}/${month}/${day}`;
    }
  }
  return result;
};

export const yupTransformDateString = (...[, originalValue]) => {
  return parseDateString(originalValue);
};

export const parseISO = (data) => {
  if (!data) {
    return null;
  }
  return dfParseISO(data);
};
